import { Component, OnInit } from '@angular/core';
import { NavService, Menu } from '../../services/nav.service';
import { Router } from '@angular/router';
import { ApiProductService } from '../../api-services/product.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfoDialogComponent } from '../modal/info-dialog/info-dialog.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  public menuItems: Menu[];
  public categories: any[] = [];

  constructor(
    private router: Router,
    public navServices: NavService,
    private apiProductService: ApiProductService,
    private ngbModal: NgbModal
  ) {
    // const dialog = this.ngbModal.open(InfoDialogComponent);
    // dialog.componentInstance.title = 'Title Modal';
    // dialog.componentInstance.text = 'Text Modal';

    this.menuItems = [
      { path: '/home', title: 'home', type: 'link' },
      { path: '/pages/aboutus', title: 'chi siamo', type: 'link' },
    ];

    this.apiProductService.categories.subscribe(
      (categories) => {
        if(categories.length > 0) {
          this.menuItems = [
            { path: '/home', title: 'home', type: 'link' },
          ];
          this.categories = categories;
          let uniqueTypes = [...new Set(this.categories.map(item => item.type))];
          uniqueTypes.forEach(
            (type) => {
              let categoriesInType = this.categories.filter((category) => {return category.type === type});
              let children = [];
              categoriesInType.forEach(
                (category) => {
                  children.push(
                    { path: '/shop', queryParams: {main: type, sub: category.name}, title: category.name, type: 'link' }
                  );
                }
              );
              
              this.menuItems.push(
                {
                  title: type, type: 'link', active: false, children: children, path: "/shop", queryParams: {main: type, sub: 'all'}
                },
              );
            }
          );

          this.menuItems.push(
            { path: '/pages/aboutus', title: 'chi siamo', type: 'link' },
          );
        }
      }
    );

    
    
    this.router.events.subscribe((event) => {
      this.navServices.mainMenuToggle = false;
    });
  }

  ngOnInit(): void {
  }

  mainMenuToggle(): void {
    this.navServices.mainMenuToggle = !this.navServices.mainMenuToggle;
  }

  // Click Toggle menu (Mobile)
  toggletNavActive(item) {
    item.active = !item.active;
  }

  onMainCategoryClick(menuItem) {
    this.router.navigate([menuItem.path], {
      queryParams: menuItem.queryParams
    });
  }

}
